import { Carousel } from 'hljd'
import React, { Component } from 'react'
import { RIGHT_BAR_PUBLISH_HREF } from '../../constants'
import styles from './style.module.less'

class RightBar extends Component {
  render() {
    return (
      <div className={styles.rightBar}>
        <div className={styles.ruleCard}>
          <h1>
            <span>发布提示</span>
            <a
              target="_blank"
              href={RIGHT_BAR_PUBLISH_HREF}
              rel="noopener noreferrer"
            >
              规则说明
            </a>
          </h1>
          <p>
            1、请准确填写案例信息，有利于案例在搜索和推荐中露出，错误填写可能面临案例下架或流量损失。
          </p>
          <p>
            2、严重虚假填写案例信息，如参考价格虚假/抄袭其他商家案例/案例被用户成功举报等行为，将记违规行为，扣除店铺积分和案例质量分。
          </p>
          <p>3、上传案例真实性举证，有助于案例真实性和原创性保护。</p>
        </div>
        <div className={styles.ruleCard}>
          <h1>实例认证案例优先曝光</h1>
          <Carousel autoplay effect="scrollx">
            <div className={styles.carouselItem}>
              <img src="https://qnm.hunliji.com/Fr5hCz9byA-nwkik_bj1m_RPulIv" />
              <div className={styles.text}>频道页&搜索页</div>
            </div>
            <div className={styles.carouselItem}>
              <img src="https://qnm.hunliji.com/FiX6oDV0cIe67-Jd41Uu3WlXGrHJ" />
              <div className={styles.text}>商家主页</div>
            </div>
            <div className={styles.carouselItem}>
              <img src="https://qnm.hunliji.com/FpPYRGtEtXLs3SX932nRUR4y-U4w" />
              <div className={styles.text}>案例相册</div>
            </div>
          </Carousel>
        </div>
      </div>
    )
  }
}

export default RightBar
